import { getDataFromServer } from '../../../util';

export class TrendAnalysisModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchTrendAnalysis = async (payload) => {
    const { customerKey, fromDate, toDate } = payload;
    const params = {
      from: fromDate,
      to: toDate
    };
    const url = `${this.baseURL}/customers/${customerKey}/scores`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchTrendAnalysisRiskLevel = async () => {
    const params = {
      metaName: 'RISKLEVEL'
    };

    const url = `${this.baseURL}/meta`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };
}
